import { Injectable } from '@angular/core';
import { Workbook } from '@progress/kendo-angular-excel-export';
import { saveAs } from '@progress/kendo-file-saver';
import { GridFieldSummary } from '~/models/modules/gridField';

@Injectable({
  providedIn: 'root',
})
export class ExcelDataService {
  exportToExcel(filename: string, rows: object[], gridColumns: GridFieldSummary[], shownColumns: any[]) {
    if (!rows || !rows.length) {
      return;
    }

    // Filter and sort keys based on selection and order, identical to the CSV service logic
    let keys = gridColumns.filter(c => c.selected && c.field).map(c => c.field);

    keys = keys.sort((a, b) =>
      (gridColumns.find(c => c.field === a)?.order ?? 0) - (gridColumns.find(c => c.field === b)?.order ?? 0) !== 0 ?
      (gridColumns.find(c => c.field === a)?.order ?? 0) - (gridColumns.find(c => c.field === b)?.order ?? 0) :
      gridColumns.findIndex(c => c.field === a) - gridColumns.findIndex(c => c.field === b)
    );

    // Extract headers
    const headers = keys.map(k => 
      gridColumns.find(c => c.field === k)?.gridFieldText?.currentText ?? gridColumns.find(c => c.field === k)?.title ?? k
    );

    // Build data rows
    const dataRows = rows.map((row: any) => {
      return keys.map(k => {
        let cell: any = '';
        if (row[k] !== undefined && row[k] !== null) {
          cell = row[k];
        } else {
          const keyArray = k.split(".");
          if (keyArray.length === 1) {
            cell = (row[k] === null || row[k] === undefined) ? '' : row[k];
          } else if (keyArray.length === 2) {
            if (Array.isArray(row[keyArray[0]])) {
              cell = (row[keyArray[0]] && row[keyArray[0]][0]) ? row[keyArray[0]][0][keyArray[1]] : null;
            } else {
              cell = row[keyArray[0]] ? row[keyArray[0]][keyArray[1]] : null;
            }
          } else if (keyArray.length === 3) {
            if (Array.isArray(row[keyArray[0]])) {
              if (!row[keyArray[0]] || row[keyArray[0]].length === 0) {
                cell = null;
              } else {
                cell = (row[keyArray[0]][0] && row[keyArray[0]][0][keyArray[1]]) ? row[keyArray[0]][0][keyArray[1]][keyArray[2]] : null;
              }
            } else {
              cell = (row[keyArray[0]] && row[keyArray[0]][keyArray[1]]) ? row[keyArray[0]][keyArray[1]][keyArray[2]] : null;
            }
          }
        }
        return cell;
      });
    });

    // Create Kendo Workbook for styling support
    const workbook = new Workbook({
      sheets: [{
        columns: keys.map(() => ({ autoWidth: true })),
        rows: [
          {
            // Header row with background and bold font
            cells: headers.map(h => ({
              value: h,
              background: '#7a7a7a',
              color: '#ffffff',
              bold: true,
              textAlign: 'center'
            }))
          },
          ...dataRows.map(row => ({
            cells: row.map(cell => ({ 
              value: cell instanceof Date ? cell.toLocaleString() : cell 
            }))
          }))
        ]
      }]
    });

    // Generate the file and trigger download
    workbook.toDataURL().then((dataUrl) => {
      saveAs(dataUrl, filename);
    });
  }
}
